import './App.css';
import { Route, Routes } from 'react-router-dom';
import Login from 'components/pages/application/login/Login';
import AdminHome from 'components/pages/admin/Home';
import AdminCompany from 'components/pages/admin/Company';
import AdminCompanyDetail from 'components/pages/admin/CompanyDetail';
import AdminPayTransaction from 'components/pages/admin/PayTransaction';
import AdminPayTransactionDetail from 'components/pages/admin/PayTransactionDetail';
import AdminPayPending from 'components/pages/admin/PayPending';
import AdminPayPendingDetail from 'components/pages/admin/PayPendingDetail';
import AccountWaitInvoice from 'components/pages/admin/AccountWaitInvoice';
import AccountWaitCheckPayment from 'components/pages/admin/AccountWaitCheckPayment';
import AccountWaitCheckWithholdingTax from 'components/pages/admin/AccountWaitCheckWithholdingTax';
import MenuAdmin from 'components/pages/admin/MenuAdmin';
import MenuAdminDetail from 'components/pages/admin/MenuAdminDetail';
import UserGroup from 'components/pages/admin/UserGroup';
import UserGroupDetail from 'components/pages/admin/UserGroupDetail';
import MenuCustomer from 'components/pages/admin/MenuCustomer'; 
import MenuCustomerDetail from 'components/pages/admin/MenuCustomerDetail';
import BlogManagement from 'components/pages/admin/BlogManagement';
import BlogManagementDetail from 'components/pages/admin/BlogManagementDetail';
import PackagePeriod from 'components/pages/admin/PackagePeriod';
import PackagePeriodDetail from 'components/pages/admin/PackagePeriodDetail';

import InvoicePending from 'components/pages/admin/AccountChecklistDetail1';
import InvoicePending2 from 'components/pages/admin/AccountChecklistDetail2';
import InvoicePending3 from 'components/pages/admin/AccountChecklistDetail3';
import InvoicePending4 from 'components/pages/admin/AccountChecklistDetail4';
import AccountCheckingDetailMain from 'components/pages/admin/AccountCheckingDetailMain';
import ListEmail from 'components/pages/admin/ListEmail';
import ConfigApp from 'components/pages/admin/ConfigApp';
import ConfigEmail from 'components/pages/admin/ConfigEmail';
import ConfigTemplateEmail from 'components/pages/admin/ConfigTemplateEmail';
import ConfigAppDetail from 'components/pages/admin/ConfigAppDetail';
import ConfigEmailDetail from 'components/pages/admin/ConfigEmailDetail';
import ConfigTemplateEmailDetail from 'components/pages/admin/ConfigTemplateEmailDetail';
import ForgotPassword from 'components/pages/application/login/ForgotPassword';
import ForgotPasswordConfirm from 'components/pages/application/login/ForgotPasswordConfirm';
import ResetPassword from 'components/pages/application/login/ResetPassword';
import ResetConfirm from 'components/pages/application/login/ResetConfirm';
import UserProfile from 'components/pages/admin/UserProfile';
import ChangePass from 'components/pages/admin/ChangePass';
import PackageList from 'components/pages/admin/PackageList';
import PackageDetail from 'components/pages/admin/PackageDetail';
import Menu from 'components/layout/Menu';
import CouponManagement from 'components/pages/admin/CouponManagement';
import CouponDetail from 'components/pages/admin/CouponDetail';
import NewsNotificationsManagement from 'components/pages/admin/NewsNotificationsManagement';
import NewsNotificationsManagementDetail from 'components/pages/admin/NewsNotificationsManagementDetail';
import UpgradeMainPackagePage from 'components/pages/admin/customer-management/pages/UpgradeMainPackagePage';
import UpgradeAddonPackagePage from 'components/pages/admin/customer-management/pages/UpgradeAddonPackagePage';


function App() {
    return (
        <Routes>
            <Route path={"/"} element={<Login />} />
            <Route path={'/home'} element={<AdminHome />} />
            <Route path={'/forgot'} element={<ForgotPassword />} />
            <Route path={'/forgot/confirm'} element={<ForgotPasswordConfirm /> } />
            <Route path={'/reset'} element={<ResetPassword />} />
            <Route path={'/reset/confirm'} element={<ResetConfirm />} />

            <Route path={'/company'} element={<AdminCompany />} />
            <Route path={'/company/detail/:id'} element={<AdminCompanyDetail />} />
            <Route path={'/company/detail/:id/upgrade-next-main-package'} element={<UpgradeMainPackagePage />} />
            <Route path={'/company/detail/:id/upgrade-add-on-package'} element={<UpgradeAddonPackagePage />} />

            <Route path={'my/profile'} element={<UserProfile/>} />
            <Route path={'my/change-password'} element={<ChangePass/>} />


            <Route path={'/sales/quontation-list'} element={<AdminPayTransaction />} />
            <Route path={'/sales/quontation-list/:id'} element={<AdminPayTransactionDetail />} />
            <Route path={'/paypendding'} element={<AdminPayPending />} />
            <Route path={'/paypendding/:id/detail'} element={<AdminPayPendingDetail />} />

            <Route path={'/account/quontation-list'} element={<AccountWaitInvoice />} />
            {/* <Route path={'/account/waiting-invoice/:id'} element={<InvoicePending /> } /> */}
            <Route path={'/account/quontation-list/:id'} element={<AccountCheckingDetailMain />} />

            <Route path={'/account/waiting-check-payment'} element={<AccountWaitCheckPayment />} />
            
            <Route path={'/account/waiting-check-payment/:id'} element={<AccountCheckingDetailMain />} />
            
            <Route path={'/account/wait-checking-withholding-tax'} element={<AccountWaitCheckWithholdingTax />} />
            <Route path={'/account/wait-checking-withholding-tax/:id'} element={<AccountCheckingDetailMain />} />
            
            <Route path={'/account/complete-documents'} element={<AdminPayTransaction />} />
            <Route path={'/account/complete-documents/:id'} element={<AccountCheckingDetailMain />} />

            <Route path={'/listemail'} element={<ListEmail />} />
            <Route path={'/setting/config-app'} element={<ConfigApp />} />
            <Route path={'/setting/config-app/:id'} element={<ConfigAppDetail />} />
            <Route path={'/setting/config-email'} element={<ConfigEmail />} />
            <Route path={'/setting/config-email/:id'} element={<ConfigEmailDetail />} />
            <Route path={'/setting/config-template-email'} element={<ConfigTemplateEmail />} />
            <Route path={'/setting/config-template-email/:id'} element={<ConfigTemplateEmailDetail />} />
            <Route path={'/setting/config-packageperiod'} element={<PackagePeriod/>}/>
            <Route path={'/setting/config-packageperiod/edit/:id'} element={<PackagePeriodDetail/>}/>
            <Route path={'/setting/config-packageperiod/create'} element={<PackagePeriodDetail/>}/>

            <Route path={'/menuadmin'} element={<MenuAdmin />} />
            <Route path={'/menuadmin/edit/:id'} element={<MenuAdminDetail />} />
            <Route path={'/menuadmin/create'} element={<MenuAdminDetail />} />

            <Route path={'/setting/package'} element={<PackageList />} />
            <Route path={'/setting/package/detail/:id'} element={<PackageDetail />} />
            <Route path={'/setting/package/create'} element={<PackageDetail />} />

            <Route path={'/usergroups'} element={<UserGroup />} />
            <Route path={'/usergroups/edit/:id'} element={<UserGroupDetail />} />
            <Route path={'/usergroups/create'} element={<UserGroupDetail />} />

            <Route path={'/menucustomer'} element={<MenuCustomer />} />
            <Route path={'/menucustomer/edit/:id'} element={<MenuCustomerDetail />} />
            <Route path={'/menucustomer/create'} element={<MenuCustomerDetail />} />

            <Route path={'/blogmanagement'} element={<BlogManagement />} />
            <Route path={'/blogmanagement/edit/:id'} element={<BlogManagementDetail />} />
            <Route path={'/blogmanagement/create'} element={<BlogManagementDetail />} />

            <Route path={'/coupon'} element={<CouponManagement />} />
            <Route path={'/coupon/edit/:id'} element={<CouponDetail />} />
            <Route path={'/coupon/create'} element={<CouponDetail />} />

            <Route path={'/manage-news-notifications'} element={<NewsNotificationsManagement />} />
            <Route path={'/manage-news-notifications/edit/:id'} element={<NewsNotificationsManagementDetail />} />
            <Route path={'/manage-news-notifications/create'} element={<NewsNotificationsManagementDetail />} />
        </Routes>
    );
}

export default App;